const NoRolePage = () => {
    return(
        <div className="tds-container">
            <p style={{ textAlign: 'center' }}>Your access to this application is not authorized.  Please contact your local security officer for Claim Status access.</p>
        </div>
    );
}
export default NoRolePage;